import React, { Component } from "react";
import _ from "lodash";
import { Form, Input, Checkbox, Typography } from "antd";
import { withRouter, Link } from "react-router-dom";

import { Button, KbankButton, Image, Modal } from "../../components";
import { withRedux } from "../../hoc";
import { fetchApi } from "../../utils";

import Summary from "./Summary";
import iconjcb from "./svg/jcb.png";
import iconmastercard from "./svg/mastercard.png";
import iconvisa from "./svg/visa.png";
import iconunionpay from "./svg/unionpay.svg";
import iconalipay from "./svg/alipay.svg";
import iconwechat from "./svg/wechat.png";

// const logo = `${process.env.PUBLIC_URL}/assets/images/logo.png`;

const { TextArea } = Input;
const { Text } = Typography;

const mapStateToProps = ({ language, t, auth }) => {
  const isAgent = _.get(auth, "data.isAgent");
  const balance = _.get(auth, "data.balance", 0);
  return {
    language,
    t,
    auth,
    authToken: _.get(auth, "token"),
    isAgent: _.get(auth, "data.isAgent"),
    isAgentPrepaid: isAgent && balance > 0,
  };
};

@withRouter
@withRedux(mapStateToProps)
class BookingStep3 extends Component {
  constructor(props) {
    super(props);
    this.kbankButtonRef = React.createRef();
    this.kbankWechatButtonRef = React.createRef();
    this.state = {
      selectPaymentMethod: "creditcard",
      isPrivatePolicy: false,
      openFullTaxInvoice: false,
      isLoading: false,
      isShowConfirm: false,
      bookedName: null,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  getData = () => {
    const { getFieldsValue } = this.props.form;
    const { comfirmBookingData, isAgent } = this.props;
    const { openFullTaxInvoice } = this.state;

    const userInfo = getFieldsValue();

    const drinkDinnerGroup = _.chain(comfirmBookingData)
      .get("drinkDinner")
      .groupBy("itemID")
      .map((i) => {
        return {
          menuID: _.get(i, [0, "menuID"]),
          itemID: _.get(i, [0, "itemID"]),
          itemCode: _.get(i, [0, "itemCode"]),
          itemName: _.get(i, [0, "itemName"]),
          qty: _.size(i),
          unitPrice: _.get(i, [0, "price"]),
          totalPrice: _.sumBy(i, "price"),
        };
      })
      .value();
    // console.log("getData comfirmBookingData ::", {
    //   comfirmBookingData,
    //   drinkDinnerGroup,
    // });

    let data = {
      amount: _.get(comfirmBookingData, "amount"),
      ShowDate: _.get(comfirmBookingData, "showDate"),
      ShowTimeID: _.get(comfirmBookingData, "showTimeID"),
      BookingSeat: _.get(comfirmBookingData, "bookingSeat"),
      // DrinkDinner: _.get(comfirmBookingData, "drinkDinner"),
      DrinkDinner: drinkDinnerGroup,
      customerName: _.get(userInfo, "name"),
      customerPhone: _.get(userInfo, "phone"),
      customerEmail: _.get(userInfo, "email"),
      branchTax: _.get(userInfo, "branchTax"),
    };

    if (isAgent) {
      data = {
        ...data,
        invoiceName: _.get(userInfo, "name"),
        invoiceAddress: _.get(userInfo, "invoiceAddress"),
        invoicePhone: _.get(userInfo, "phone"),
        taxId: openFullTaxInvoice ? _.get(userInfo, "taxId") : null,
        invoiceEmail: _.get(userInfo, "email"),
      };
    } else {
      if (openFullTaxInvoice) {
        data = {
          ...data,
          invoiceName: _.get(userInfo, "invoiceName"),
          invoiceAddress: _.get(userInfo, "invoiceAddress"),
          invoicePhone: _.get(userInfo, "invoicePhone"),
          taxId: _.get(userInfo, "taxId"),
          invoiceEmail: _.get(userInfo, "invoiceEmail"),
        };
      }
    }

    return data;
  };

  getPaymentMethods = () => {
    const { selectPaymentMethod } = this.state;
    const { comfirmBookingData, authToken, t } = this.props;
    const data = this.getData();
    const amount = _.get(data, "amount");
    const currency = "THB";
    const name = "Tiffany";
    const description = "Tiffany Ticket";
    const ShowDate = _.get(data, "ShowDate");
    const ShowTimeID = _.get(data, "ShowTimeID");
    const BookingSeat = JSON.stringify(_.get(data, "BookingSeat"));
    const DrinkDinner = JSON.stringify(_.get(data, "DrinkDinner"));
    const customerName = _.get(data, "customerName");
    const customerPhone = _.get(data, "customerPhone");
    const customerEmail = _.get(data, "customerEmail");

    const invoiceName = _.get(data, "invoiceName");
    const invoiceAddress = _.get(data, "invoiceAddress");
    const invoicePhone = _.get(data, "invoicePhone");
    const taxId = _.get(data, "taxId");
    const invoiceEmail = _.get(data, "invoiceEmail");
    const branchTax = _.get(data, "branchTax");

    console.log("getPaymentMethods ::", {comfirmBookingData, "data-order-id": _.get(comfirmBookingData, 'orderId')});

    const paymentMethods = [
      {
        key: "creditcard",
        name: t("Credit / Debit Card"),
        info: (
          <div>
            <div className="container-image-card">
              <Image src={iconjcb} alt="" />
              <Image src={iconmastercard} alt="" />
              <Image src={iconvisa} alt="" />
            </div>
            {!_.isEmpty(comfirmBookingData) &&
              selectPaymentMethod === "creditcard" && (
                <KbankButton
                  id="creditcard-form"
                  ref={this.kbankButtonRef}
                  action={`${process.env.REACT_APP_SERVICE}/${process.env.REACT_APP_API}/payment/kbank/creditcard/main/website`}
                  mid={process.env.REACT_APP_KBANK_MAIN_MERCHANT_ID}
                  authToken={authToken}
                  amount={amount}
                  currency={currency}
                  paymentMethods="card"
                  name={name}
                  description={description}
                  ShowDate={ShowDate}
                  ShowTimeID={ShowTimeID}
                  BookingSeat={BookingSeat}
                  DrinkDinner={DrinkDinner}
                  customerName={customerName}
                  customerPhone={customerPhone}
                  customerEmail={customerEmail}
                  invoiceName={invoiceName}
                  invoiceAddress={invoiceAddress}
                  invoicePhone={invoicePhone}
                  taxId={taxId}
                  invoiceEmail={invoiceEmail}
                  branchTax={branchTax}
                  onError={(error) => console.log("KbankButton error", error)}
                />
              )}
          </div>
        ),
        submit: () => this.kbankButtonRef.current.submit(),
      },
      {
        key: "unionpay",
        name: t("UnionPay"),
        info: (
          <div>
            <div className="container-image-card">
              <Image src={iconunionpay} alt="" />
            </div>
            <form
              id="unionpay-form"
              method="POST"
              action={`${process.env.REACT_APP_SERVICE}/${process.env.REACT_APP_API}/payment/kbank/creditcard/tpn/website`}
            >
              <input type="hidden" name="authToken" value={authToken} />
              <input type="hidden" name="amount" value={amount} />
              <input type="hidden" name="currency" value={currency} />
              <input type="hidden" name="description" value={description} />
              <input type="hidden" name="ShowDate" value={ShowDate} />
              <input type="hidden" name="ShowTimeID" value={ShowTimeID} />
              <input type="hidden" name="BookingSeat" value={BookingSeat} />
              <input type="hidden" name="DrinkDinner" value={DrinkDinner} />
              <input type="hidden" name="customerName" value={customerName} />
              <input type="hidden" name="customerPhone" value={customerPhone} />
              <input type="hidden" name="customerEmail" value={customerEmail} />
              <input type="hidden" name="invoiceName" value={invoiceName} />
              <input
                type="hidden"
                name="invoiceAddress"
                value={invoiceAddress}
              />
              <input type="hidden" name="invoicePhone" value={invoicePhone} />
              <input type="hidden" name="taxId" value={taxId} />
              <input type="hidden" name="invoiceEmail" value={invoiceEmail} />
              <input type="hidden" name="branchTax" value={branchTax} />
            </form>
          </div>
        ),
        submit: async () => {
          document.getElementById("unionpay-form").submit();
        },
      },
      {
        key: "thaiqrcode",
        name: t("Thai QR Code"),
        info: (
          <div>
            <div className="container-image-card"></div>
            <form
              id="thaiqrcode-form"
              method="POST"
              action={`${process.env.REACT_APP_SERVICE}/${process.env.REACT_APP_API}/payment/kbank/thaiqr/website`}
            >
              <input type="hidden" name="authToken" value={authToken} />
              <input type="hidden" name="amount" value={amount} />
              <input type="hidden" name="currency" value={currency} />
              <input type="hidden" name="description" value={description} />
              <input type="hidden" name="ShowDate" value={ShowDate} />
              <input type="hidden" name="ShowTimeID" value={ShowTimeID} />
              <input type="hidden" name="BookingSeat" value={BookingSeat} />
              <input type="hidden" name="DrinkDinner" value={DrinkDinner} />
              <input type="hidden" name="customerName" value={customerName} />
              <input type="hidden" name="customerPhone" value={customerPhone} />
              <input type="hidden" name="customerEmail" value={customerEmail} />
              <input type="hidden" name="invoiceName" value={invoiceName} />
              <input
                type="hidden"
                name="invoiceAddress"
                value={invoiceAddress}
              />
              <input type="hidden" name="invoicePhone" value={invoicePhone} />
              <input type="hidden" name="taxId" value={taxId} />
              <input type="hidden" name="invoiceEmail" value={invoiceEmail} />
              <input type="hidden" name="branchTax" value={branchTax} />
            </form>
          </div>
        ),
        submit: async () => {
          document.getElementById("thaiqrcode-form").submit();
        },
      },
      {
        key: "wechat",
        name: "WeChat",
        info: (
          <div>
            <div className="container-image-card">
              <Image src={iconwechat} alt="" />
            </div>
            <form
              id="wechat-form"
              method="POST"
              action={`${process.env.REACT_APP_SERVICE}/${process.env.REACT_APP_API}/payment/kbank/wechat/website`}
            >
              <input type="hidden" name="authToken" value={authToken} />
              <input type="hidden" name="amount" value={amount} />
              <input type="hidden" name="currency" value={currency} />
              <input type="hidden" name="description" value={description} />
              <input type="hidden" name="ShowDate" value={ShowDate} />
              <input type="hidden" name="ShowTimeID" value={ShowTimeID} />
              <input type="hidden" name="BookingSeat" value={BookingSeat} />
              <input type="hidden" name="DrinkDinner" value={DrinkDinner} />
              <input type="hidden" name="customerName" value={customerName} />
              <input type="hidden" name="customerPhone" value={customerPhone} />
              <input type="hidden" name="customerEmail" value={customerEmail} />
              <input type="hidden" name="invoiceName" value={invoiceName} />
              <input
                type="hidden"
                name="invoiceAddress"
                value={invoiceAddress}
              />
              <input type="hidden" name="invoicePhone" value={invoicePhone} />
              <input type="hidden" name="taxId" value={taxId} />
              <input type="hidden" name="invoiceEmail" value={invoiceEmail} />
              <input type="hidden" name="branchTax" value={branchTax} />
            </form>
            {selectPaymentMethod === "wechat" && (
              <script
                type="text/javascript"
                src={process.env.REACT_APP_KBANK_GATEWAY_URL}
                data-apikey={process.env.REACT_APP_KBANK_PUBLIC_KEY}
                data-amount={amount}
                data-currency={currency}
                data-payment-methods="wechat"
                data-name={name}
                data-description={description}
                data-mid={process.env.REACT_APP_KBANK_WECHAT_MERCHANT_ID}
                data-order-id={_.get(comfirmBookingData, 'orderId')}
              />
            )}
          </div>
        ),
        submit: async () => {
          document.getElementById("wechat-form").submit();
        },
      },
      {
        key: "alipay",
        name: "Alipay",
        info: (
          <div>
            <div className="container-image-card">
              <Image src={iconalipay} alt="" />
            </div>
            <form
              id="alipay-form"
              method="POST"
              action={`${process.env.REACT_APP_SERVICE}/${process.env.REACT_APP_API}/payment/kbank/alipay/website`}
            >
              <input type="hidden" name="amount" value={amount} />
              <input type="hidden" name="currency" value={currency} />
              <input type="hidden" name="description" value={description} />
              <input type="hidden" name="ShowDate" value={ShowDate} />
              <input type="hidden" name="ShowTimeID" value={ShowTimeID} />
              <input type="hidden" name="BookingSeat" value={BookingSeat} />
              <input type="hidden" name="DrinkDinner" value={DrinkDinner} />
              <input type="hidden" name="customerName" value={customerName} />
              <input type="hidden" name="customerPhone" value={customerPhone} />
              <input type="hidden" name="customerEmail" value={customerEmail} />
              <input type="hidden" name="invoiceName" value={invoiceName} />
              <input
                type="hidden"
                name="invoiceAddress"
                value={invoiceAddress}
              />
              <input type="hidden" name="invoicePhone" value={invoicePhone} />
              <input type="hidden" name="taxId" value={taxId} />
              <input type="hidden" name="invoiceEmail" value={invoiceEmail} />
              <input type="hidden" name="branchTax" value={branchTax} />
            </form>
          </div>
        ),
        submit: async () => {
          document.getElementById("alipay-form").submit();
        },
      },
    ];
    return paymentMethods;
  };

  submitPaymentForm = () => {
    const { selectPaymentMethod } = this.state;
    const paymentMethods = this.getPaymentMethods();
    const paymentMethod = _.find(paymentMethods, { key: selectPaymentMethod });
    paymentMethod.submit();
  };

  submitAgentPrepaid = async () => {
    this.setState({
      isShowConfirm: false,
      isLoading: true,
    });
    const { authToken, comfirmBookingData, auth } = this.props;
    const { bookedName } = this.state;
    const url = "booking/agent/prepaid/booking";

    const drinkDinnerGroup = _.chain(comfirmBookingData)
      .get("drinkDinner")
      .groupBy("itemID")
      .map((i) => {
        return {
          menuID: _.get(i, [0, "menuID"]),
          itemID: _.get(i, [0, "itemID"]),
          itemCode: _.get(i, [0, "itemCode"]),
          itemName: _.get(i, [0, "itemName"]),
          qty: _.size(i),
          unitPrice: _.get(i, [0, "price"]),
          totalPrice: _.sumBy(i, "price"),
        };
      })
      .value();

    const dataPost = {
      ShowDate: _.get(comfirmBookingData, "showDate"),
      ShowTimeID: _.get(comfirmBookingData, "showTimeID"),
      BookingSeat: _.get(comfirmBookingData, "bookingSeat"),
      // DrinkDinner: _.get(comfirmBookingData, "drinkDinner"),
      DrinkDinner: drinkDinnerGroup,
      customerName: bookedName,
      customerPhone: _.get(auth, "data.profile.senate_Phone"),
      customerEmail: _.get(auth, "data.email"),
      invoiceAddress: _.get(auth, "data.profile.senate_BillAddress"),
    };

    const data = this.getData();

    // console.log("submitAgentPrepaid comfirmBookingData ::", {
    //   dataPost,
    //   data,
    // });

    const headers = {
      Authorization: `Bearer ${authToken}`,
    };

    const result = await fetchApi(
      url,
      "POST",
      JSON.stringify(dataPost),
      headers
    );

    this.setState({
      isLoading: false,
    });

    if (_.get(result, "status") === "success") {
      window.location.replace(
        `${window.location.origin}/booking?status=success&key=${_.get(
          result,
          "data.key"
        )}`
      );
    } else {
      window.location.replace(
        `${window.location.origin}/booking?status=fail&message=${_.get(
          result,
          "message"
        )}`
      );
    }
  };

  handleSubmitPaymentForm = (e) => {
    const { isAgentPrepaid } = this.props;
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        if (isAgentPrepaid) {
          this.setState({
            isShowConfirm: true,
            bookedName: _.get(values, "name"),
          });
        } else {
          this.submitPaymentForm();
        }
      }
    });
  };

  render() {
    const {
      selectPaymentMethod,
      isPrivatePolicy,
      openFullTaxInvoice,
      isLoading,
      isShowConfirm,
    } = this.state;
    const { getFieldDecorator } = this.props.form;
    const {
      t,
      auth,
      isAgent,
      isAgentPrepaid,
      comfirmBookingData,
      selectedShowtime,
      selectedDate,
    } = this.props;

    const agentName = _.get(auth, "data.profile.senate_AgentName");
    const agentTaxNo = _.get(auth, "data.profile.senate_TaxNo");
    const agentAddress = _.get(auth, "data.profile.senate_BillAddress");
    const agentPhone = _.get(auth, "data.profile.senate_Phone");
    const agentBranchTax = _.get(auth, "data.profile.senate_BranchTax");
    const agentEmail = _.get(auth, "data.email");

    let agentPrepaidInputStyle = {};
    if (isAgentPrepaid) {
      agentPrepaidInputStyle = {
        pointerEvents: "none",
        border: "none",
        resize: "none",
      };
    }

    const paymentMethods = this.getPaymentMethods();
    return (
      <div className="booking-step-3">
        <Form onSubmit={this.handleSubmitPaymentForm} className="payment-form">
          {isAgent ? (
            <div className="container-info-user">
              <div className="row">
                <div className="col-md-5">
                  <h2>{t("Information")}</h2>
                </div>
                <div className="col-md-6 form-block">
                  <Form.Item label={t("Name")}>
                    {getFieldDecorator("name", {
                      rules: [
                        {
                          required: true,
                          message: "This field is required.",
                        },
                      ],
                    })(<Input />)}
                  </Form.Item>
                  <Form.Item label={t("Agent Name")}>
                    {getFieldDecorator("agentName", {
                      initialValue: agentName,
                    })(
                      <Input
                        style={{ pointerEvents: "none", border: "none" }}
                      />
                    )}
                  </Form.Item>
                  <Form.Item label={t("Tax ID")}>
                    {getFieldDecorator("taxId", {
                      initialValue: agentTaxNo,
                    })(
                      <Input
                        style={{ pointerEvents: "none", border: "none" }}
                      />
                    )}
                  </Form.Item>
                  <Form.Item label={t("Branch Number")}>
                    {getFieldDecorator("branchTax", {
                      initialValue: agentBranchTax,
                    })(
                      <Input
                        style={{ pointerEvents: "none", border: "none" }}
                      />
                    )}
                  </Form.Item>
                  <Form.Item label={t("Address")}>
                    {getFieldDecorator("invoiceAddress", {
                      initialValue: agentAddress,
                      rules: [
                        {
                          required: !isAgentPrepaid,
                          message: "This field is required.",
                        },
                      ],
                    })(
                      <TextArea
                        autoSize={{ minRows: 3, maxRows: 6 }}
                        style={isAgentPrepaid ? agentPrepaidInputStyle : {}}
                      />
                    )}
                  </Form.Item>
                  <Form.Item label={t("Email")}>
                    {getFieldDecorator("email", {
                      initialValue: agentEmail,
                    })(
                      <Input
                        style={{ pointerEvents: "none", border: "none" }}
                      />
                    )}
                  </Form.Item>
                  <Form.Item label={t("Phone Number")}>
                    {getFieldDecorator("phone", {
                      initialValue: agentPhone,
                      rules: [
                        {
                          required: !isAgentPrepaid,
                          message: "This field is required.",
                        },
                      ],
                    })(
                      <Input
                        style={isAgentPrepaid ? agentPrepaidInputStyle : {}}
                      />
                    )}
                  </Form.Item>

                  <div className="container-full-tax-invoice">
                    <div className="checkbox-holder">
                      <Checkbox
                        onChange={() =>
                          this.setState({
                            isPrivatePolicy: !isPrivatePolicy,
                          })
                        }
                      />
                      <p>
                        I have read and accept{" "}
                        <Link to="/pdpa/privacy-policy" target="_blank">
                          the Privacy Policy
                        </Link>{" "}
                        and{" "}
                        <Link to="/pdpa/terms-of-use" target="_blank">
                          Term of Use
                        </Link>
                      </p>
                    </div>
                  </div>
                  {!isAgentPrepaid && (
                    <React.Fragment>
                      <div className="container-full-tax-invoice">
                        <div className="checkbox-holder">
                          <Checkbox
                            onChange={() =>
                              this.setState({
                                openFullTaxInvoice: !openFullTaxInvoice,
                              })
                            }
                          />
                          <p>{t("Do you need full tax invoice?")}</p>
                        </div>
                      </div>
                    </React.Fragment>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <div className="container-info-user">
              <div className="row">
                <div className="col-md-5">
                  <h2>{t("Information")}</h2>
                </div>
                <div className="col-md-6 form-block">
                  <Form.Item label={t("Name")}>
                    {getFieldDecorator("name", {
                      rules: [
                        {
                          required: true,
                          message: "Please input your Name",
                        },
                      ],
                    })(<Input />)}
                  </Form.Item>
                  <Form.Item label={t("Email")}>
                    {getFieldDecorator("email", {
                      rules: [
                        {
                          type: "email",
                          message: "The input is not valid Email",
                        },
                        {
                          required: true,
                          message: "Please input your Email",
                        },
                      ],
                    })(<Input />)}
                  </Form.Item>
                  <Form.Item label={t("Phone Number")}>
                    {getFieldDecorator("phone", {})(<Input />)}
                  </Form.Item>

                  <div className="container-full-tax-invoice">
                    <div className="checkbox-holder">
                      <Checkbox
                        onChange={() =>
                          this.setState({
                            isPrivatePolicy: !isPrivatePolicy,
                          })
                        }
                      />
                      <p>
                        I have read and accept{" "}
                        <Link to="/pdpa/privacy-policy" target="_blank">
                          the Privacy Policy
                        </Link>{" "}
                        and{" "}
                        <Link to="/pdpa/terms-of-use" target="_blank">
                          Term of Use
                        </Link>
                      </p>
                    </div>
                  </div>
                  <div className="container-full-tax-invoice">
                    <div className="checkbox-holder">
                      <Checkbox
                        onChange={() =>
                          this.setState({
                            openFullTaxInvoice: !openFullTaxInvoice,
                          })
                        }
                      />
                      <p>{t("Do you need full tax invoice?")}</p>
                    </div>
                    {openFullTaxInvoice && (
                      <div className="detail-full-tax-invoice">
                        <Form.Item label={t("Company / Personal Tax ID")}>
                          {getFieldDecorator("taxId", {
                            rules: [
                              {
                                required: true,
                                message:
                                  "Please input your Company / Personal Tax ID",
                              },
                            ],
                          })(<Input />)}
                        </Form.Item>
                        <Form.Item label={t("Company / Personal Name")}>
                          {getFieldDecorator("invoiceName", {
                            rules: [
                              {
                                required: true,
                                message:
                                  "Please input your Company / Personal Name",
                              },
                            ],
                          })(<Input />)}
                        </Form.Item>
                        <Form.Item label={t("Branch Tax")}>
                          {getFieldDecorator("branchTax", {
                            rules: [
                              {
                                len: 5,
                                message: "Please input 5 Digit!",
                              },
                              {
                                pattern: /^[0-9]+$/,
                                message: "Please input only number!",
                              },
                            ],
                          })(<Input />)}
                        </Form.Item>
                        <Form.Item label={t("Email")}>
                          {getFieldDecorator("invoiceEmail", {
                            rules: [
                              {
                                required: true,
                                message: "Please input your Email",
                              },
                            ],
                          })(<Input />)}
                        </Form.Item>
                        <Form.Item label={t("Phone Number")}>
                          {getFieldDecorator("invoicePhone", {
                            rules: [
                              {
                                required: true,
                                message: "Please input your Phone Number",
                              },
                            ],
                          })(<Input />)}
                        </Form.Item>
                        <Form.Item label={t("Address")}>
                          {getFieldDecorator("invoiceAddress", {
                            rules: [
                              {
                                required: true,
                                message: "Please input your Address",
                              },
                            ],
                          })(
                            <TextArea autoSize={{ minRows: 3, maxRows: 6 }} />
                          )}
                        </Form.Item>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </Form>
        <Summary
          selectedData={_.get(comfirmBookingData, "bookingSeat")}
          selectedFoods={_.get(comfirmBookingData, "drinkDinner")}
          selectedShowtime={selectedShowtime}
          selectedDate={selectedDate}
        />
        {!isAgentPrepaid && (
          <div>
            <div className="remark-text">
              <Text type="danger">
                {t(
                  "Please check your billing address before making the payment."
                )}
              </Text>
            </div>
            <div className="container-card-detail">
              <h2>{t("Payment Method")}</h2>
              <div className="card-detail-block">
                {_.map(paymentMethods, (paymentMethod) => {
                  const key = _.get(paymentMethod, "key");
                  const name = _.get(paymentMethod, "name");
                  const info = _.get(paymentMethod, "info");
                  const active = key === selectPaymentMethod;
                  return (
                    <div
                      key={key}
                      className={`card-detail ${active ? "active" : ""}`}
                      onClick={() => {
                        if (selectPaymentMethod === key) return;
                        this.setState({ selectPaymentMethod: key });
                      }}
                    >
                      <h3 className="name">{name}</h3>
                      <div className="detail">{info}</div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        )}

        <div className="container-button">
          <Button
            className="large"
            ghost
            bordercolor="#ffb400"
            onClick={() => this.props.onClickPrev()}
          >
            {t("Previous")}
          </Button>
          <Button
            className="large"
            type="primary"
            onClick={this.handleSubmitPaymentForm}
            disabled={!isPrivatePolicy}
          >
            {t("Next Step")}
          </Button>
        </div>
        <Modal
          className="loading-modal"
          type="full"
          centered
          visible={isLoading}
        >
          <p className="loading-text">
            {t("Your booking is being processed. Please wait")}
          </p>
        </Modal>
        <Modal
          className="confirm-modal"
          centered
          visible={isShowConfirm}
          onCancel={() => this.setState({ isShowConfirm: false })}
        >
          <p className="confirm-text">
            {t(
              "The amount will be deducted from your remaining balance, click confirm to proceed"
            )}
          </p>
          <div className="button-confirm-block">
            <Button
              className="large"
              type="primary"
              onClick={this.submitAgentPrepaid}
            >
              {t("Confirm")}
            </Button>
          </div>
        </Modal>
      </div>
    );
  }
}

export default Form.create()(BookingStep3);



// WEBPACK FOOTER //
// ./src/pages/Booking/BookingStep3.js